import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import _find from 'lodash/find';
import { normalizeTab } from '@/search/utils';
import { useSearchContext } from '../../context/search';

export default ({
  tabsData,
  sortsData,
  searchType,
  searchTerm,
  hasLoadMore,
}) => {
  const { t } = useTranslation();
  const [
    state,
    {
      setTabs,
      setSorts,
      setSearchType,
      setSearchTerm,
      setLoadMore,
      setFirstQuery,
    },
  ] = useSearchContext();
  useEffect(() => {
    const tabs = normalizeTab({ tabs: JSON.parse(tabsData), searchType, t });
    const activeTab = _find(tabs, { isActive: true });
    const sorts = JSON.parse(sortsData);
    const dataUrl = new URLSearchParams(window.location.search);
    dataUrl.set('searchType', searchType);
    dataUrl.set('hasLoadMore', hasLoadMore);
    const initialUrl = `${window.location.pathname}?${dataUrl.toString()}`;
    const initialQuery = {
      value: dataUrl.get('q') || searchTerm,
      url: initialUrl,
    };
    setTabs(tabs);
    setSorts(sorts);
    setLoadMore(hasLoadMore);
    setSearchType(searchType);
    setSearchTerm(searchTerm);
    setFirstQuery(initialQuery);

    // replace state w/ initialState
    window.history.replaceState(
      {
        ...state,
        tabs,
        activeTab,
        query: initialQuery,
        hasLoadMore,
        searchType,
        searchTerm,
      },
      null,
      initialUrl,
    );
  }, []);
};
